module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), (_vm.currentPage !== 0) ? _c('div', {
    staticClass: "next mobi",
    on: {
      "click": _vm.turnTop
    }
  }, [_vm._v("")]) : _vm._e(), (_vm.currentPage === 0) ? _c('div', {
    staticClass: "next mobi",
    on: {
      "click": _vm.turnNext
    }
  }, [_vm._v("")]) : _vm._e(), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page page_home",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[0]),
      expression: "animateCtrl[0]"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].bannerTitle1)), _c('br'), _c('div', {
    staticClass: "main"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].bannerTitle2))])])]), _c('banner', {
    ref: "banner",
    staticClass: "banner",
    attrs: {
      "imgs": _vm.banner
    }
  }), _c('page', {
    ref: "banner_navigation",
    staticClass: "navigation",
    attrs: {
      "total": 3
    },
    on: {
      "prev": _vm.bannerPrev,
      "next": _vm.bannerNext
    }
  }), _c('transition', {
    attrs: {
      "name": "top-in"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[0]),
      expression: "animateCtrl[0]"
    }],
    staticClass: "mouse pc",
    attrs: {
      "src": require('../assets/mouse.png')
    }
  })]), _c('timeline', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage === 0),
      expression: "currentPage === 0"
    }],
    ref: "banner_timeline",
    staticClass: "timeline pc",
    attrs: {
      "percent": _vm.indexTime
    },
    on: {
      "reset": _vm.banner_resetTime
    }
  })], 1), _c('div', {
    staticClass: "page page_contact",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1]),
      expression: "animateCtrl[1]"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title",
    on: {
      "click": function($event) {
        return _vm.$router.push('/contact')
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].contact))]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1]),
      expression: "animateCtrl[1]"
    }],
    staticClass: "template"
  }, [_c('div', {
    staticClass: "city",
    on: {
      "click": function($event) {
        return _vm.switchCity('beijing')
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].beijing))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobi || _vm.showingCity == 'beijing'),
      expression: "isMobi || showingCity == 'beijing'"
    }],
    staticClass: "detail"
  }, [_c('p', [_vm._v("+86 10 6563 0026")]), _c('p', [_vm._v(" " + _vm._s(_vm.langs[_vm.lang].addressBeijing))])]), _c('div', {
    staticClass: "city",
    on: {
      "click": function($event) {
        return _vm.switchCity('shanghai')
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].shanghai))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobi || _vm.showingCity == 'shanghai'),
      expression: "isMobi || showingCity == 'shanghai'"
    }],
    staticClass: "detail"
  }, [_c('p', [_vm._v("+86 21 6418 7585")]), _c('p', [_vm._v(" " + _vm._s(_vm.langs[_vm.lang].addressShanghai))])])])])], 1)]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _c('a', {
    staticClass: "c2",
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("京ICP备13001817号-4")]), _c('div', {
    staticClass: "c"
  }, [_vm._v("© 2022贝塔斯曼亚洲投资基金 ALL RIGHTS RESERVED")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72e49152","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 514
// module chunks = 1